<template>
  <div class="card mb-25 border-0 radius-7 bg-white sales-pos-location-box">
    <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
      <div
        class="mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between"
      >
        <div class="title">
          <span class="fw-medium text-muted fs-13 d-block mb-5 text-uppercase">
            Gravações do ano
          </span>
          <h4 class="card-title fw-black mb-0">{{ getDashboardYearCards.date }}</h4>
        </div>
      </div>
      <div id="weeklySalesChart" class="chart mt-20">
        <apexchart
          type="area"
          height="375"
          :options="weeklySalesChart"
          :series="[
            {
              name: 'UPLOADS COM SUCESSO', 
              data: Object.values(getDashboardYearTable).map(month => month.total_success)
            },
            {
              name: 'UPLOADS COM ERRO', 
              data: Object.values(getDashboardYearTable).map(month => month.total_error)
            },
          ]"
        ></apexchart>
      </div>

      <div class="justify-content-around mt-20 row p-10">
        <div class="metric-dashboard-year-graphic-information radius-7 bg-primary mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3">
          <i class="ph ph-check-circle"></i> Uploads com sucesso: {{ getDashboardYearCards.total_success }}
        </div>
        <div class="metric-dashboard-year-graphic-information radius-7 bg-danger mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3">
          <i class="ph ph-warning-circle"></i> Uploads com erro: {{ getDashboardYearCards.total_error }}
        </div>
        <div class="metric-dashboard-year-graphic-information radius-7 bg-success col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3">
          <i class="ph ph-clock-countdown"></i> Tempo total: {{ convertTime(getDashboardYearCards.total_time) }}
        </div>
      </div>
      <div class="justify-content-around mt-20 row p-10">
        <div class="metric-dashboard-year-graphic-information radius-7 bg-info mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3">
          <i class="ph ph-soundcloud-logo"></i> Tamanho total: {{ (getDashboardYearCards.total_size / (1024 * 1024)).toFixed(2) + " MB" }}          
        </div>
        <div class="metric-dashboard-year-graphic-information radius-7 bg-mini-green mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3">
          <i class="ph ph-cloud-sun"></i> AM: {{ getDashboardYearCards.am }}
        </div>
        <div class="metric-dashboard-year-graphic-information radius-7 bg-dark mb-10 col-12 col-sm-12 col-lg-3 col-xl-3 col-xxl-3 col-xxxl-3">
          <i class="ph ph-cloud-moon"></i> PM: {{ getDashboardYearCards.pm }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { mapGetters } from 'vuex';
import moment from 'moment';

export default defineComponent({
  name: "MetricDashboardYearGraphic",
  data: function () {
    return {
      weeklySalesChart: {
        chart: {
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "smooth",
          width: 2
        },
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.7,
            opacityTo: 0.9,
            stops: [0, 90, 100]
          }
        },
        colors: ["#159269", "#C33F52"],
        legend: {
          position: "top",
          fontSize: "14px",
          fontWeight: 500,
          horizontalAlign: "center",
          fontFamily: "Red Hat Display, sans-serif",
          labels: {
            colors: "#607089",
          },
          markers: {
            offsetY: -1,
            offsetX: -4,
            height: 15,
            width: 15
          },
          itemMargin: {
            horizontal: 10,
          },
        },
        grid: {
          show: true,
          strokeDashArray: 5,
          borderColor: "#dfe7f1",
        },
        tooltip: {
          style: {
            fontSize: "14px",
            fontFamily: "Red Hat Display, sans-serif",
          }
        },
        xaxis: {
          categories: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
          labels: {
            show: true,
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: "#607089",
              fontSize: "14px",
              fontWeight: 500,
            },
          },
          axisTicks: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          tooltip: {
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: "#10223b",
              fontSize: "14px",
            },
          },
        },
        yaxis: {
          show: true,
          labels: {
            style: {
              fontFamily: "Red Hat Display, sans-serif",
              colors: ["#607089"],
              fontSize: "14px",
              fontWeight: 500,
            },
            formatter: function (value) {
              return Math.round(value);
            }
          },
        },
      },
    };
  },
  methods: {
    convertTime(time: number | string) {
      const totalSeconds = Math.max(0, Math.floor(Number(time) || 0)); // lida com "96000.01243"
      const d = moment.duration(totalSeconds, 'seconds');

      const hours = Math.floor(d.asHours()); // horas **totais**, não %24
      const minutes = d.minutes();
      const seconds = d.seconds();

      const pad = (n: number) => String(n).padStart(2, '0');
      return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`; // ex.: 26:40:00
    }
  },
  computed:{
    ...mapGetters([
      "getDashboardYearCards",
      "getDashboardYearTable"
    ])
  },
});
</script>
